// extracted by mini-css-extract-plugin
export var quantityInput = "_ip-0";